import { animated, useSpring } from '@react-spring/web';
import React, { useEffect, useRef } from 'react';
import './Sidebar.scss';

const Sidebar = ({ handleClose, children }) => {
  const sidebarRef = useRef(null);

  const springProps = useSpring({
    from: { transform: 'translateX(80%)', opacity: 0 },
    to: { transform: 'translateX(0)', opacity: 1 },
    config: { tension: 150, friction: 30 },
    width: '100%',
    height: '100%',
  });

  // Close sidebar on outside click
  useEffect(() => {
    const handleClickOutside = event => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        handleClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClose]);

  return (
    <div className='overlay_wrapper'>
      <animated.div className='overlay_wrapper__sidebar' style={springProps} ref={sidebarRef}>
        {children}
      </animated.div>
    </div>
  );
};

export default Sidebar;
